'use client'

import { MobileFooter } from 'shared/common/Footer/components/MainFooter/Mobile/Footer'
import { getCookie } from 'shared/libs/storage/cookie'

import { IconButton } from 'shared/ui/iconButton'

import { useDisclosure } from 'shared/hooks/useDisclosure'

import { globalStyles } from 'shared/config/styles/globalStyles'

import styles from './HeaderBurger.module.scss'

export function HeaderBurger() {
  const isWebview = getCookie('isWebview') === 'true'
  const { isOpen, onClose, onOpen } = useDisclosure()

  if (isWebview) return null

  return (
    <>
      <IconButton
        onClick={onOpen}
        iconColor={globalStyles['--icon-secondary']}
        iconName="burger"
        buttonType="squired"
        buttonColor="extra"
        className={styles.burger}
        iconSize="medium"
      />
      {isOpen && <MobileFooter isOpen={isOpen} onClose={onClose} />}
    </>
  )
}
